import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { AxiosError } from "axios";
import { ErrorDTO } from "interface";
import { MAG_HOME_END_POINTS } from "core/constants/endpoints";
import instance from "core/constants/request";
import { homeSliderForm } from "../../type";

const updateMagHomeSlider = async ({ data }: { data: homeSliderForm }) => {
  const formData = new FormData();
  formData.append("Id", String(data.id ?? "0"));
  formData.append("Priority", String(data.priority ?? "0"));
  formData.append("AltText", data.altText ?? "");
  formData.append("Name", data.name ?? "");
  formData.append("Url", data.url ?? "");
  formData.append("IsActive", String(data.isActive ?? "false"));
  formData.append("Description1", data?.description1 ?? "");
  formData.append("Description2", data?.description2 ?? "");

  const res = await instance.put(MAG_HOME_END_POINTS.update_slider, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });

  const imageFormData = new FormData();
  imageFormData.append("Id", String(data?.id ?? 0));
  if (data.uploadImage?.file) {
    imageFormData.append("Image.AltText", data?.altText ?? "");
    imageFormData.append("Image.Width", String(data.uploadImage.width));
    imageFormData.append("Image.Height", String(data.uploadImage.height));
    imageFormData.append("Image.SizePercentage", "100");
    imageFormData.append("Image.File", data.uploadImage.file);
  }
  if (data.mobileUploadImage?.file) {
    imageFormData.append("MobileImage.AltText", data?.altText ?? "");
    imageFormData.append(
      "MobileImage.Width",
      String(data.mobileUploadImage.width)
    );
    imageFormData.append(
      "MobileImage.Height",
      String(data.mobileUploadImage.height)
    );
    imageFormData.append("MobileImage.SizePercentage", "100");
    imageFormData.append("MobileImage.File", data.mobileUploadImage.file);
  }
  if (data.uploadImage?.file || data.mobileUploadImage?.file) {
    await instance.post(
      MAG_HOME_END_POINTS.update_slider_image,
      imageFormData,
      {
        headers: { "Content-Type": "multipart/form-data" },
      }
    );
  }

  return res.data;
};

export const useUpdateMagHomeSlider = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: [
      MAG_HOME_END_POINTS.update_slider,
      MAG_HOME_END_POINTS.sliders_list,
    ],
    mutationFn: updateMagHomeSlider,
    onError: (e: AxiosError<ErrorDTO>) => {
      toast.error(`${e.response?.data.Message || "خطا در ویرایش اسلایدر"}`);
    },
    onSuccess: () => {
      toast.success(`اسلایدر با موفقیت ویرایش شد`);
      queryClient.invalidateQueries({
        queryKey: [MAG_HOME_END_POINTS.sliders_list],
      });
    },
  });
};
